import "reflect-metadata";
import React, { Component } from "react";
import { Link } from "react-router-dom";
import pencilIcon from "assets/pencil-icon.svg";
import LoginComponent from "components/login/login.component";
import { TypedConnect } from "models/store";
import { IAuthenticationState } from "sthinds.io-lib";
import { ApolloClient } from "@apollo/client";
import "./header.component.scss";

interface IHeaderComponentProps {
  client?: ApolloClient;
  /** Injected by connect(), so callers do not have to thread them through. */
  dispatch?: (action: unknown) => void;
  authentication?: IAuthenticationState;
}

const mapStateToProps = (state: { authentication: IAuthenticationState }) => {
  return {
    authentication: state?.authentication,
  };
};

const mapDispatchToProps = (dispatch: unknown) => {
  return { dispatch };
};

/**
 * Site-wide top bar: identity on the left, authoring and account controls on
 * the right. Replaces the former fixed left margin, which spent 240px of every
 * viewport on a name and two icons.
 */
@TypedConnect(mapStateToProps, mapDispatchToProps)
export default class HeaderComponent extends Component<IHeaderComponentProps> {
  state = { menuOpen: false };

  private closeMenu = () => this.setState({ menuOpen: false });

  render() {
    const isLoggedIn = this.props.authentication?.isLoggedIn;

    return (
      <header className="top-bar">
        <Link to="/" className="top-bar-identity">
          <span className="top-bar-name">Sean Hinds</span>
          <span className="top-bar-tagline">Blog &amp; Portfolio</span>
        </Link>
        <nav className="top-bar-actions">
          {/* Authoring is owner-only; logged-out visitors get the login control
              beside it, so there is no longer a reason to show a write link
              that only redirects to OAuth. */}
          {isLoggedIn ? (
            <Link to="/article/create" className="top-bar-write">
              <img src={pencilIcon} height={16} alt="" />
              <span>Write</span>
            </Link>
          ) : null}
          {/* LoginComponent is itself connect()ed: it reads authentication and
              dispatch from the store, so these props are formality only. */}
          <LoginComponent
            authenticationState={this.props.authentication as IAuthenticationState}
            dispatch={this.props.dispatch as (action: unknown) => void}
            client={this.props.client}
          ></LoginComponent>
        </nav>
        <button
          type="button"
          className="mobile-menu-toggle"
          aria-expanded={this.state.menuOpen}
          aria-controls="mobile-site-menu"
          onClick={() => this.setState(({ menuOpen }) => ({ menuOpen: !menuOpen }))}
        >
          Menu
        </button>
        <nav
          id="mobile-site-menu"
          className={`mobile-site-menu${this.state.menuOpen ? " is-open" : ""}`}
          aria-label="Site navigation"
        >
          <Link to="/" onClick={this.closeMenu}>
            Home
          </Link>
          <Link to="/#posts" onClick={this.closeMenu}>
            Posts
          </Link>
          {isLoggedIn ? (
            <Link to="/article/create" onClick={this.closeMenu}>
              Write
            </Link>
          ) : null}
        </nav>
      </header>
    );
  }
}
